// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__33DC9","image":"Header_image__1WXfC","name":"Header_name__2__eg","info":"Header_info__2zjNa","infoRow":"Header_infoRow__3jpUT"};